import React from 'react';
import { ReactComponent as Match } from '../../assets/images/icons/match.svg';

export default function MatchIcon(props) {
  return (
    <Match className={`icon ${props.className}`} />
  );
}
